/* Brand marks shared by the hero logo marquee and the team stack tiles. */
export const techLogos = {
  react: {
    accent: "#61dafb",
    svg: `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="2.2" fill="#61DAFB"/>
      <ellipse cx="12" cy="12" rx="10.5" ry="4.1" stroke="#61DAFB" stroke-width="1.1" fill="none"/>
      <ellipse cx="12" cy="12" rx="10.5" ry="4.1" stroke="#61DAFB" stroke-width="1.1" fill="none" transform="rotate(60 12 12)"/>
      <ellipse cx="12" cy="12" rx="10.5" ry="4.1" stroke="#61DAFB" stroke-width="1.1" fill="none" transform="rotate(120 12 12)"/>
    </svg>`,
  },

  node: {
    accent: "#68a063",
    svg: `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 1.6 2.9 6.85v10.3L12 22.4l9.1-5.25V6.85L12 1.6Z" fill="#339933"/>
      <text x="12" y="15.1" font-size="8.4" font-family="Sora, Arial, sans-serif" font-weight="700" text-anchor="middle" fill="#fff">JS</text>
    </svg>`,
  },

  python: {
    accent: "#ffd343",
    svg: `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 2C8.1 2 7.7 3.74 7.7 3.74L7.65 5.9h4.35v1.45H5.9S3 7.1 3 11.05v2.35c0 3.5 2.05 3.5 2.05 3.5h1.95v-1.7c0-3.45 2.95-3.35 2.95-3.35h4.55c2.65 0 2.5-2.05 2.5-2.05V5.25C16.95 2.9 12 2 12 2Zm-2.35 1.95a.85.85 0 1 1 0 1.7.85.85 0 0 1 0-1.7Z" fill="#3776AB"/>
      <path d="M12 22c3.9 0 4.3-1.74 4.3-1.74l.05-2.16h-4.35v-1.45h6.1S21 16.9 21 12.95v-2.35c0-3.5-2.05-3.5-2.05-3.5h-1.95v1.7c0 3.45-2.95 3.35-2.95 3.35H9.6c-2.65 0-2.5 2.05-2.5 2.05v3.85C7.05 21.1 12 22 12 22Zm2.35-1.95a.85.85 0 1 1 0-1.7.85.85 0 0 1 0 1.7Z" fill="#FFD43B"/>
    </svg>`,
  },

  typescript: {
    accent: "#3178c6",
    svg: `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect width="24" height="24" rx="4" fill="#3178C6"/>
      <text x="12" y="15.5" font-size="9.6" font-family="Sora, Arial, sans-serif" font-weight="700" text-anchor="middle" fill="#fff">TS</text>
    </svg>`,
  },

  dotnet: {
    accent: "#8b5cf6",
    svg: `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect width="24" height="24" rx="4" fill="#512BD4"/>
      <text x="12" y="14.4" font-size="6.6" font-family="Sora, Arial, sans-serif" font-weight="700" text-anchor="middle" fill="#fff">.NET</text>
    </svg>`,
  },

  aws: {
    accent: "#ff9900",
    svg: `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <g fill="#FF9900">
        <circle cx="8" cy="12.4" r="3.6"/>
        <circle cx="12.5" cy="9.8" r="4.5"/>
        <circle cx="16.6" cy="12.4" r="3.4"/>
        <rect x="8" y="11.8" width="8.6" height="4.2"/>
      </g>
      <path d="M5.6 19.3c3.9 1.9 8.9 1.8 12.8-.3" stroke="#232F3E" stroke-width="1.5" stroke-linecap="round"/>
      <path d="m16.9 17.7 1.7.6-.5 1.7" stroke="#232F3E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`,
  },

  docker: {
    accent: "#2496ed",
    svg: `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M13.56 10.2h1.7V8.5h-1.7v1.7Zm-2.18 0h1.7V8.5h-1.7v1.7Zm-2.17 0h1.7V8.5H9.21v1.7Zm4.35 0h1.7V8.5h-1.7v1.7Zm-6.52 0h1.7V8.5H7.04v1.7Zm8.7 0h1.7V8.5h-1.7v1.7Zm-2.17 0h1.7V8.5h-1.7v1.7Zm-6.53 1.7h1.7v-1.7H7.04v1.7Zm2.17 0h1.7v-1.7H9.21v1.7Zm2.17 0h1.7v-1.7h-1.7v1.7Zm2.18 0h1.7v-1.7h-1.7v1.7Zm2.17 0h1.7v-1.7h-1.7v1.7Zm-10.87 0h1.7v-1.7H4.87v1.7Z" fill="#2496ED"/>
      <path d="M21.72 10.78c-.2-.65-.68-1.22-1.34-1.5a2.4 2.4 0 0 0-1.02-.2H5.98l-.04-.11a10.8 10.8 0 0 0-1.05-2.15C3.98 5.72 2.93 4.7 1.65 4.1L1.35 3.95l.14.32c.87 1.6 1.14 3.42.78 5.2l-.02.09h12.42c.5 0 .96.2 1.3.54.34.34.53.82.53 1.32 0 .5-.19.98-.53 1.32-.34.34-.8.54-1.3.54H7.7v1.32h6.65c.96 0 1.88-.38 2.57-1.05.69-.67 1.08-1.58 1.08-2.52 0-.48-.09-.95-.27-1.38l.02-.02c1.24-.6 2.16-1.7 2.46-3.01Z" fill="#2496ED"/>
    </svg>`,
  },

  flutter: {
    accent: "#47c5fb",
    svg: `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M14.3 2 4 12.3l3.2 3.2L20.7 2h-6.4Z" fill="#47C5FB"/>
      <path d="M14.3 11.5 9.3 16.5l3.2 3.2 8.2-8.2h-6.4Z" fill="#47C5FB"/>
      <path d="m9.3 16.5 3.2-3.2 3.2 3.2-3.2 3.2-3.2-3.2Z" fill="#00569E"/>
    </svg>`,
  },

  sql: {
    accent: "#336791",
    svg: `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M4 6v12c0 1.8 3.6 3.2 8 3.2s8-1.4 8-3.2V6H4Z" fill="#336791"/>
      <path d="M4 10.2c0 1.8 3.6 3.2 8 3.2s8-1.4 8-3.2M4 14.3c0 1.8 3.6 3.2 8 3.2s8-1.4 8-3.2" stroke="#1F4A72" stroke-width="1.2"/>
      <ellipse cx="12" cy="6" rx="8" ry="3.2" fill="#5B93C9"/>
    </svg>`,
  },

  pytorch: {
    accent: "#ee4c2c",
    svg: `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M9.4 8.1A6.4 6.4 0 1 0 14.6 8.1" stroke="#EE4C2C" stroke-width="2.5" stroke-linecap="round"/>
      <path d="M9.4 8.1 12 3.4" stroke="#EE4C2C" stroke-width="2.5" stroke-linecap="round"/>
      <circle cx="15.7" cy="6.5" r="1.4" fill="#EE4C2C"/>
    </svg>`,
  },

  github: {
    accent: "#24292f",
    svg: `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path fill="#24292F" d="M12 1.2C5.99 1.2 1.2 6.08 1.2 12.18c0 4.84 3.13 8.95 7.48 10.4.55.1.75-.24.75-.53 0-.26-.01-1.13-.02-2.05-3.04.66-3.68-1.46-3.68-1.46-.5-1.27-1.22-1.6-1.22-1.6-.99-.68.08-.67.08-.67 1.1.08 1.67 1.13 1.67 1.13.97 1.67 2.55 1.19 3.17.91.1-.71.38-1.19.69-1.46-2.42-.28-4.97-1.21-4.97-5.4 0-1.19.42-2.16 1.12-2.92-.11-.28-.49-1.39.11-2.89 0 0 .91-.29 2.99 1.12.87-.24 1.8-.36 2.72-.37.93 0 1.86.12 2.73.37 2.08-1.41 2.98-1.12 2.98-1.12.6 1.5.22 2.61.11 2.89.7.76 1.11 1.73 1.11 2.92 0 4.2-2.56 5.11-5 5.38.39.34.74 1.01.74 2.04 0 1.47-.01 2.66-.01 3.02 0 .29.2.63.76.52 4.36-1.45 7.5-5.56 7.5-10.4 0-6.1-4.87-10.98-10.88-10.98Z"/>
    </svg>`,
  },
};

export const techLogoOrder = ["react", "node", "python", "typescript", "dotnet", "aws", "docker", "github"];
